import React, { Suspense } from 'react'
import { CContainer, CSpinner } from '@coreui/react-pro'

// routes config
import AppBreadcrumb from './AppBreadcrumb'
import PropTypes from 'prop-types'

const AppContent = ({ children }) => {
  return (
    <CContainer fluid className="px-4">
      <AppBreadcrumb />
      <Suspense fallback={<CSpinner color="primary" />}>{children}</Suspense>
    </CContainer>
  )
}

AppContent.propTypes = {
  children: PropTypes.node,
}

export default React.memo(AppContent)
